<template>
	<div>
		<header class="lmy-header lmy-header-w">
            <i class="iconfont icon-yuyin" @click="isLeave=true"></i>
        	填写订单
    	</header>
		<div class="fill-order">
			<div class="hotel-msg">
				<p class="fill-order-title">{{bookInfo.HotelName}}</p>
				<p>入离:{{bookInfo.CheckIn|dateShort}}-{{bookInfo.CheckOut|dateShort}}  | 共{{bookInfo.days}}晚</p>
				<p>{{bookInfo.RoomName}} | {{bookInfo.RPName}}</p>	
				<p class="fill-tip">{{bookInfo.CancelPolicy}}</p>
			</div>
			<ul class="fill-msg">
				<li class="items">
					<p class="fill-order-title fill-title">入住信息</p>
					<!-- 不可删 触发事件 -->
					<!-- <div class="flex-box room-msg" @click="controlSelectPage(true,'房间数',bookInfo.RoomCount)"> -->
					<div class="flex-box room-msg">
						<p class="lable-first">房间数</p>
						<p >
							<span class="room-num">{{bookInfo.RoomCount}}间</span>
							<span class="prople-num-tip">每间最多住2人</span>
						</p>
						<!-- 不可删  触发事件时需要按钮-->
						<!-- <i class="iconfont icon-more"></i> -->
						
					</div>
				</li>
				<li class="items" v-if="bookInfo.From==1">
					<p class="lable-first">入住人</p>
					<div class="people flex-box" v-for="(adult,index) in Adults">
						<p class="lable-second">房间{{index+1}}</p>
						<div class="name-f">
							<p class="name-lable">姓</p>
							<input class="name-value" type="text" v-model="adult.LastName" placeholder="张">
						</div>
						<div class="name-s">
							<p class="name-lable">名</p>
							<input class="name-value" type="text" v-model="adult.FirstName" placeholder="三">
						</div>
					</div>
				</li>
				<li class="items" v-if="bookInfo.From==0">
					<p class="lable-first">入住人</p>
					<div class="people flex-box" v-for="(room,index) in frAdults" :key="index">
						<p class="lable-second">房间{{index+1}}</p>
						<div class="fr-people-box">
						<div  v-for="(person,i) in room" class="fr-people" :key="i">
							<div class="name-f">
								<p class="name-lable">姓</p>
								<input class="name-value" type="text" :placeholder="person.IsChild?'儿童/英文或拼音':'英文或拼音'" onkeyup="this.value=this.value.replace(/[\u4e00-\u9fa5\d]/gi,'');" v-model="person.LastName">
							</div>
							<div class="name-s">
								<p class="name-lable">名</p>
								<input class="name-value" type="text" :placeholder="person.IsChild?'儿童/英文或拼音':'英文或拼音'" onkeyup="this.value=this.value.replace(/[\u4e00-\u9fa5\d]/gi,'');"  v-model="person.FirstName">
							</div>
						</div>
						</div>
					</div>
				</li>
				<li class="items">
					<div class="flex-box">
						<p class="lable-first">手机号</p>
						<input type="text" v-model="Phone" placeholder="用于接收通知短信">
					</div>

				</li>
				<li class="items">
					<p class="fill-order-title fill-title">住客对酒店的特殊要求</p>
					<ul class="select-list">
						<li :class="item.isSelect?'list-item active':'list-item'" v-for="item in specialList" @click="item.isSelect=!item.isSelect">{{item.value}}</li>
						
					</ul>
					<div class="flex-box isshow-inv" @click="isInvoiceBox=true">
						<p class="lable-first">发票</p>
						<div class="inv-btn">{{isInvoice?'增值税普通发票':'不需要开票'}}</div>
						<i class="iconfont icon-more"></i>
					</div>
				</li>

			</ul>
			<div class="order-bottom">
				<div class="price">
					<span class="new" v-if="!newPrice">
						<span class="txt">应付:</span>
						<span class="sym">￥</span>
						<span class="num">{{(bookInfo.AdultPrice*bookInfo.RoomCount)-(PromotionDate.Amount||0)}}</span>
					</span>
					<span class="new" v-else>
						<span class="txt">应付:</span>
						<span class="sym">￥</span>
						<span class="num">{{newPrice}}</span>
					
					</span>
					<span class="price-detail" @click="isPriceDetailsShow=!isPriceDetailsShow">明细<i :class="isPriceDetailsShow?'xiala active':'xiala'"></i></span>
				</div>
				<p class="order-btns" @click="submit">去支付</p>
			</div>

		</div>
		<!-- <div class="lmy-fill-order"> 
			<div class="room-info">
				<p class="room-name">{{bookInfo.HotelName}}</p>
				<p>入离:{{bookInfo.CheckIn|dateShort}}-{{bookInfo.CheckOut|dateShort}}  | 共{{bookInfo.days}}晚</p>
				<p>{{bookInfo.RoomName}} | {{bookInfo.RPName}}</p>			
			</div>
			<div class="list-change">
				<i class="iconfont icon-dingdan"></i>
				{{bookInfo.CancelPolicy}}				
			</div>
			<div class="room-people-toast">
				港澳及海外酒店必须填写英文或拼音
			</div>


			国内订单填写
			<div class="room-people" v-if="bookInfo.From==1">
				<div class="people" v-for="(adult,index) in Adults">
					<div class="room-people-title">房间{{index+1}}</div>
					<div class="room-people-content">
						<div class="room-people-input">
							<input type="text" v-model="adult.LastName" placeholder="姓">
						</div>
						<div class="room-people-input">
							<input type="text" v-model="adult.FirstName" placeholder="名" >
						</div>
					</div>
				</div>
				<div class="tel">
					<div class="room-tel-title">手机号</div>
					<div class="room-tel-content">
						<input type="text" placeholder="用于接收通知短信"  v-model="Phone" >
					</div>
				</div>
			</div>

			海外订单填写
			<div class="room-people" v-if="bookInfo.From==0">
				<div class="people-foreign" >
					<div class="room-people-title">入住人</div>
					<div class="room-people-content">
						<div class="room-people-input" v-for="(room,index) in frAdults">
							<div class="people-input-head">客房{{index+1}}</div>
							<div class="people-input-body" v-for="person in room">
								<input class="first-name"  type="text" :placeholder="person.IsChild?'姓(英文或拼音)/儿童':'姓(英文或拼音)'" oninput="this.value=this.value.replace(/[\u4e00-\u9fa5\d]/g,'');" v-model="person.LastName">
								<input class="last-name" type="text" :placeholder="person.IsChild?'名(英文或拼音)/儿童':'名(英文或拼音)'" oninput="this.value=this.value.replace(/[\u4e00-\u9fa5\d]/g,'');"  v-model="person.FirstName">
							</div>
						</div>
					</div>
				</div>
				<div class="tel">
					<div class="room-tel-title">手机号</div>
					<div class="room-tel-content">
						<input type="text" placeholder="用于接收通知短信" v-model="Phone"/>
					</div>
				</div>
			</div>
			<div class="room-special">
				住客对酒店的特殊要求
				<i class="iconfont icon-xiala"></i>
			</div>
			<div class="room-special-select">
				<ul class="select-list">
					<li :class="item.isSelect?'list-item active':'list-item'" v-for="item in specialList" @click="item.isSelect=!item.isSelect">{{item.value}}</li>
				</ul>
				<div class="other-info">
					<div class="other-info-title">补充说明：</div>
					<div class="other-info-input">
						<textarea placeholder="内容请在30字以内" v-if="bookInfo.From==1" v-model="SpecialRequest"></textarea>
						<textarea placeholder="内容请在30字以内(英文)"  oninput="this.value=this.value.replace(/[\u4e00-\u9fa5\d]/g,'');"  v-if="bookInfo.From==0" v-model="SpecialRequest"></textarea>
					</div>
				</div>
			</div>
			<div class="agree agree2 room-special ticket-special">
                <label for="agree">
					<input id="agree" type="checkbox" v-model="isInvoice" @click="isInvoice = !isInvoice"/>
					是否开发票
				</label>
            </div>
			<div class="agree">
				<label for="agree">
					<input id="agree" type="checkbox" v-model="isAgree"/>
					我已阅读并同意<span class="c-agree">{{bookInfo.CancelPolicy}}</span>
				</label>
			</div>
			<div class="order-btm">
				<div class="price">
					<span class="new">
						￥
						<span class="order-first-discount" v-if="isFirstBook">{{bookInfo.AdultPrice}}</span>
						<span>{{bookInfo.AdultPrice}}</span>
					</span>
					<div class="price-detail" @click="isPriceDetailsShow=!isPriceDetailsShow">明细<i class="iconfont icon-xiala"></i></div>
				</div>
				<div class="order-btns" @click="submit">去支付</div>
			</div>
		</div>	  -->
		<div class="cmpnt-modal-box" v-if="isLeave">
			<div class="lmy-mask-s"></div>
		    <div class="lmy-modal">
		        <!-- <div class="lmy-modal-head"></div> -->
		        <div class="lmy-modal-body">
		            <p>订单尚未完成 ,确定要离开？</p>
		        </div>
		        <div class="lmy-modal-foot">
		            <div class="sort-btn" onclick="window.history.go(-1)">离开</div>
		            <div class="sort-btn" @click="isLeave=false">不离开</div>
		        </div>
		    </div>	
	    </div>	
		<div class="pricte-detail-box" v-if="isPriceDetailsShow">
				<div class="shade" @click="isPriceDetailsShow=false"></div>
				<div class="pricte-detail">
					<div class="title">费用明细</div>
					<div class="txt" v-for='sp in bookInfo.Surcharges'>
						<p>
							{{sp.Name}}
						</p>
						<p class="right">
							￥{{sp.Price}}
						</p>
					</div>
					<div class="txt" v-for='dr in bookInfo.DailyRates'>
						<p>
							{{dr.Date|dateShort}}  房费  {{bookInfo.Breakfast||''}} 
						</p>
						<p class="right">
							￥{{dr.AdultPrice}} x {{bookInfo.RoomCount}}
						</p>
					</div>
					<div class="txt" v-if="PromotionDate&&PromotionDate.Amount">
						<p>{{PromotionDate.Desc}}</p>
						<p class="right">
							<span class="sym">减 ￥{{PromotionDate.Amount}}</span>
						</p>
					</div>
					<div class="txt" v-if="newPrice">
						<p>
							优惠金额
						</p>
						<p class="right">
							<span class="sym">￥</span>
							{{(bookInfo.AdultPrice*bookInfo.RoomCount)-newPrice}}
						</p>
					</div>
					<div class="txt">
						<p>
							微信支付
						</p>
						<p class="right total" v-if="newPrice">
							<span class="sym">￥</span>
							{{newPrice}}
						</p>
						<p class="right total" v-else>
							<span class="sym">￥</span>
							{{(bookInfo.AdultPrice*bookInfo.RoomCount)-(PromotionDate.Amount||0)}}
						</p>
					</div>
				</div>
		</div>
	    <!-- <div class="cmpnt-modal-box" v-if="isPriceDetailsShow" @click="isPriceDetailsShow=false">
			
		    <div class="lmy-fill-mask">
				<div class="mask-title">费用明细</div>

				<div class="detail-info" v-for='sp in bookInfo.Surcharges' > 
					{{sp.Name}}  
					<span class="amount">￥{{sp.Price}}</span>
				</div>
				<div class="detail-info" v-for='dr in bookInfo.DailyRates'> 
					{{dr.Date|dateShort}}  房费  {{bookInfo.Breakfast||''}} 
					<span class="amount">￥{{dr.AdultPrice}} x {{bookInfo.RoomCount}}</span>
				</div>
			</div>
		</div> -->
		<div class="book-comfirming" v-if="isSubmit">
		    <div class='f-modal' >
	            <div class='f-modal-head'>提示</div>
	            <div class='f-modal-body'>
	                <p>正在核实产品信息，请稍候</p>
	            </div>
	        </div>
	    </div>
		<invoice v-show="isInvoiceBox==true" @offInvoice="offInvoice" @modifyInvoice="modifyInvoice" :payPricy="this.bookInfo.AdultPrice*this.bookInfo.RoomCount" :salePrice='salePrice' :Currency="bookInfo.Currency" ></invoice>
		<roomAndPerson @select="rpData.select" v-show="rpData.show" :rpData="rpData" ></roomAndPerson>
		<transition  name="slide" >
            <selectPage v-if="selectPageType.show" :title="selectPageType.type" :active="selectPageType.active" :maxCount="maxCount" @getSelectData="getSelectData" @showPage="controlSelectPage"></selectPage>
        </transition>
	</div>

	
</template>
<script>
	import Invoice from './../invoice/invoice.vue';//发票
	import roomAndPerson from './../common/cmpnt/roomAndPerson.vue';//酒店房间和入住人数
	import selectPage from './../common/cmpnt/selectPage.vue';//选择
	
	export default{
		name:'book',
		components:{
			Invoice,
			roomAndPerson,
			selectPage
		},
		data(){
			return{
				bookInfo:JSON.parse(this.dao.get('bookInfo')),
				isLeave:false,
				isSubmit:false,
				isAgree:true,
				isPriceDetailsShow:false,
				Phone:JSON.parse(this.dao.get('userInfo')).Phone,
				Adults:[],
				frAdults:[],
				Childrens:[],
				SpecialRequest:'',
				specialList:[
			        {'name':'安静房间','index':'-1', 'enValue':'Quiet Room', 'value':'安静房间','isSelect':false},
			        {'name':'无障碍房','index':'0',  'enValue':'Accessible Room', 'value':'无障碍房','isSelect':false},
			        {'name':'立即到店','index':'1',  'enValue':'Arrival Immediate', 'value':'立即到店','isSelect':false},
			        {'name':'无烟房','index':'2',    'enValue':'Non-Smoking Room', 'value':'无烟房','isSelect':false},
			        {'name':'提前到店','index':'3',  'enValue':'Arrival In Advance', 'value':'提前到店','isSelect':false},
			        {'name':'蜜月度假','index':'4',  'enValue':'Honeymoon Holiday', 'value':'蜜月度假','isSelect':false},
			        {'name':'高楼层','index':'5',    'enValue':'High Floor ', 'value':'高楼层','isSelect':false},
			        {'name':'尽量双床','index':'6',  'enValue':'Prefer Twin Beds', 'value':'尽量双床','isSelect':false},
			        {'name':'尽量大床','index':'7',  'enValue':'Prefer Double Bed', 'value':'尽量大床','isSelect':false},
			        // {'name':'免费安排婴儿车','index':'8','enValue':'Free Baby Cot', 'value':'免费安排婴儿车','isSelect':false},
							{'name':'连通房','index':'9','enValue':'Connecting Rooms', 'value':'连通房','isSelect':false},
					
				],
				// 是否需要开票
				isInvoice:false,
				// 开票信息
				isInvoiceBox:false,
				salePrice:'',
				invoiceData:{},
				rpData:{
                    show:false,
                    RoomCount:this.dao.get('bookInfo')?JSON.parse(this.dao.get('bookInfo')).RoomCount:1,
                    AdultCount:this.dao.get('bookInfo')?JSON.parse(this.dao.get('bookInfo')).AdultCount:2,
                    ChildrenCount:this.dao.get('bookInfo')?JSON.parse(this.dao.get('bookInfo')).ChildrenCount:0,
                    ChildrenAges:this.dao.get('bookInfo')?JSON.parse(this.dao.get('bookInfo')).ChildrenAges:'',
					from:1,
					maxCount:this.dao.get('bookInfo')?JSON.parse(this.dao.get('bookInfo')).Stock:1,
                    select:(val)=>{
						this.rpData.show=false;
						this.newBookInfo(val)
                    }
				},
				maxCount:this.dao.get('bookInfo')?JSON.parse(this.dao.get('bookInfo')).Stock:1,
				selectPageType:{'show':false,'type':'房间数','active':''},
				RoomCountData:{value:1,lable:'1间'},
				coupon:'',
				couponToken:'',
				newPrice:'',
				// 新客立减信息
				PromotionDate:''
			}
		},
		
		methods:{
			//优惠券码验证
			checkCoupon() {
				var that = this;
				var params = {
					Token: that.bookInfo.Token,
					Code: that.coupon,
					Count:1
				}
				that.isSubmit = true
				that.postRequest({
					url: that.Api.checkCoupon,
					params: params
				}).then(res => {
					that.isSubmit = false
					if (res && res.IsSuccess) {
						this.couponToken = res.Result.Token
						this.newPrice = res.Result.NewAmount
					} else {
						that.$alert("抱歉！您的优惠券无效或已被使用");
					}
				});
			},
			// 显示-隐藏 选项页
            controlSelectPage(bool,type,active){
                this.selectPageType.show = bool
                if(type){
                    this.selectPageType.type = type
                    this.selectPageType.active=active
                }
            },
            // 获得选项信息
            getSelectData(item,type){
                if(type=='房间数'){
					this.RoomCountData = item
					this.newBookInfo()
                }
            },
			// 是否开发票
			modifyInvoice(item,value){
				this.isInvoiceBox = false
				this.isInvoice = item
				this.invoiceData =value
				console.log(this.invoiceData)
			},
			// 开票页返回时触发事件
			offInvoice(){
				this.isInvoiceBox = false
				this.isInvoice = false
			},
			newBookInfo(val){
				
				this.bookInfo.RoomCount=this.RoomCountData.value
				this.bookInfo.AdultPrice=Number(this.bookInfo.AdultPrice*this.RoomCountData.value)
				this.dao.set('bookInfo',JSON.stringify(this.bookInfo));
				this.initialAdultInfo()
			},
			initialAdultInfo(){
 		 		var AdultCount=this.bookInfo.AdultCount;
 		 		var RoomCount=this.bookInfo.RoomCount;
 		 		var ChildrenCount=this.bookInfo.ChildrenCount;
 		 		var ChildrenAges=this.bookInfo.ChildrenAges;
 		 	
 		 		var that=this;
 		 		var frAdults=[];
 		 		var Adults=[];
				
 		 		if(that.bookInfo.From==0){
					for(var i=0;i<RoomCount;i++){
						frAdults[i]=[];
						for(var j=0;j<AdultCount;j++){
							var item={'FirstName':'','LastName':'','Age':'','IsChild':false,'Phone':'','CardNumber':''};
							frAdults[i].push(item);
						}
						for(var m=0;m<ChildrenCount;m++){

							var item={'FirstName':'','LastName':'','Age':ChildrenAges[m]||5,'Phone':'','CardNumber':''};
							frAdults[i].push(item);
						}
	 		 		}
	 		 		that.$nextTick(function () {
			    		that.frAdults=frAdults;
					})
					
 		 		}else{
					for(var i=0;i<RoomCount;i++){
 		 				var item={'FirstName':'','LastName':'','Age':'','IsChild':'','Phone':'','CardNumber':''};
						Adults.push(item);
					}
					that.Adults=Adults;
 		 		}

 		 	
 		 	},
			checkBookAble(token,callback){
				if(!token){
					callback();
				}

				var that=this;
				that.isSubmit=true;
				var param={
					token:token
				}
				that.isLoadingIcon=true;
				that.postRequest({
						url:that.Api.checkBookable, 
						params:param
					}).then(res => {
						that.isLoadingIcon=false;
						that.isSubmit=false;
						//当IsSuccess==true时，表示有库存可以预订
					    if(res){
					    	if(res.IsSuccess){
								callback();
					    	}else{
 								this.error({title:'提示',content:res.Msg||'不能预订'});
					    	}
					    	
					    }
				});	
			},
			isFrCustomerInfoCorrect(list){
 		 		for(var i=0,length=list.length;i<length;i++){
 		 			for(var j=0;j<list[i].length;j++){
 		 				if(!list[i][j].FirstName||!list[i][j].LastName){
							return false;
						}
 		 			}
 		 		}
 		 		return true;
 		 	},
			isCustomerInfoCorrect(list){
 		 		for(var i=0,length=list.length;i<length;i++){
 		 			if(!list[i].FirstName||!list[i].LastName){
						return false;
					}
 		 		}
 		 		return true;
 		 	},
 		 	specialListInitial(list){
 		 		
 		 		var str=''
 		 		for(var i=0;i<list.length;i++){
					if(list[i].isSelect){
						if(this.bookInfo.From==1){
							str+=list[i].name+' ';
						}else{
							str+=list[i].enValue+' ';
						}
						
					}
 		 		}
 		 		str+=this.remarks||'';
 		 		return str;

 		 	},
 		 	initFrGuests(list){
 		 		var guest=[];
 		 		
 		 		for(var i=0;i<list.length;i++){
 		 			for(var j=0;j<list[i].length;j++){
						guest.push(list[i][j]);
 		 			}

 		 		}
 		 		return guest;

 		 	},
	 		submit(){
 		 		
 		 		var that=this;
 		 		var userInfo=this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):'';

 		 	// 	var CanBooking=userInfo.CanBooking||'';
 		 		
 				// if(!CanBooking){
	 			// 	this.error({title:'提示',content:'该账号没有预订权限！请先确认！'});
					// return;
	 			// }
	 			
	 			//判断用户信息是否输入完整
	 			
	 			if(that.bookInfo.From==0){
	 				
					if(!that.isFrCustomerInfoCorrect(that.frAdults)){
						that.$alert('请正确填写用户信息！')
		 	 			return;
		 	 		}
	 			}else{
	 				if(!that.isCustomerInfoCorrect(that.Adults)){
						that.$alert('请正确填写用户信息！')
		 	 			return;
		 	 		}

	 			}
 		 		if(!that.Phone){
					that.$alert('请填写手机号码！')
					return;
 		 		}

 		 		if(!this.checkMobile(that.Phone))return;

 		 		
 		 		if(!that.isAgree){
					that.$alert('请先同意预订规则！')
					return;
 		 		}

	  			
 		 		//检查是否可以预订
				that.checkBookAble(that.bookInfo.Token,function(){
					var Guests='';
				
					if(that.bookInfo.From==0){
						Guests=that.initFrGuests(that.frAdults);

					}else{
						Guests=that.Adults;
					}
				
	 		 		var SpecialRequest=that.specialListInitial(that.specialList);
	 		 		var param={
						SpecialRequest:SpecialRequest+that.SpecialRequest,
						Guests:Guests,
						Phone:that.Phone,
						Token:that.bookInfo.Token,
						Amount:that.PromotionDate.Amount||'',
						IsInvoice:that.isInvoice,
						Invoices:that.isInvoice?that.invoiceData:{},
						// PromotionsToken:that.couponToken,
						PromotionsToken:that.PromotionDate.Token||'',
						newPrice:that.newPrice,
					}
	 		 		that.dao.set('bookRequest',JSON.stringify(param));
	 		 		
	 		 		that.$router.replace('/bookComfain');
	
				})
 		 	},
			// 是否满足立减
			getPromotions(){
				var that=this;
				that.getRequest({
						url:that.Api.getPromotions, 
						params:''
					}).then(res => {
						if(res.IsSuccess&&res.Result.length>0){
							res.Result.forEach(item => {
								if(that.bookInfo.AdultPrice*that.bookInfo.RoomCount<=item.MaxPrice&&that.bookInfo.AdultPrice*that.bookInfo.RoomCount>=item.MinPrice){
									that.PromotionDate = item
									that.salePrice = item.Amount
								}
							});
					  }
				});	
			},
		},
		mounted(){
			this.initialAdultInfo();
			this.getPromotions()
			// 先隐藏优惠券
			// this.coupon = JSON.parse(this.dao.get('hotelCoupon'))||''
			// if(this.coupon){
			// 	this.checkCoupon()
			// }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/book/book.vue